'use strict';

import Hook from './Hook.js';
import SignUpStep from './SignUpStep.js';
import DefaultFields from './DefaultFields.js';
import ManageSteps from './ManageSteps.js';
import TeamsFlows from './TeamsFlows.js';
import P2PFlows from './P2PFlows.js';
import { DOM } from '../../helpers/DOM.js';
import {display} from "../../../../../../../wp-includes/js/codemirror/csslint.js";
import CRMFlow from "./CRMFlow.js";
import { ChoiceSelect} from "../ChoiceSelect.js";

export class MultiStepForms{

    formWrapper = null;
    formSteps = [];
    currentStep = 1;
    stepsCount = 1;
    previousStep = null;

    childClasses = {};

	/**
	 * @type {Hook}
	 */
	Hook;

	#sentSubmitRequest = false;

    constructor () {
        this.formWrapper = document.querySelector('.levcharity-multi-step-form-wrapper');

		const choices = new ChoiceSelect();
		choices.multiSelect('.choose-equipment-multiple-choices');

        if (this.formWrapper) {
            this.Hook = new Hook();

            this.formSteps = [...this.formWrapper.children];
            this.currentStep = parseInt(this.formWrapper?.dataset?.startStep || 1);
            this.stepsCount = this.formSteps.length;

            this.childClasses = {
                DefaultFields: new DefaultFields(this),
                SignUpStep: new SignUpStep(this),
                ManageSteps: new ManageSteps(this),
            };

            if (document.querySelector('.levcharity-multi-step-form-wrapper.team-campaigns')){
                this.childClasses.TeamsFlows = new TeamsFlows(this);
            }

            if (document.querySelector('.levcharity-multi-step-form-wrapper.p2p-campaigns')){
                this.childClasses.P2PFlows = new P2PFlows(this);
            }

			if (document.querySelector('.levcharity-multi-step-form-wrapper.crm')) {
				this.childClasses.CRMFlow = new CRMFlow(this);
			}

            this.#addEvents();
            this.#addWatchers();

			this.Hook.doAction('init');

			this.#addFilters();
			this.#addActions();
        }
    }

	#addFilters() {
		this.Hook.addFilter('sendSubmitRequest', (canSubmit, form, formAction) => {
			if (this.#sentSubmitRequest) {
				return false;
			}

			return canSubmit;
		})
	}

	#addActions() {

		this.Hook.addAction('beforeSubmitRequestSent', (sendSubmitRequest, form, formAction) => {
			this.#sentSubmitRequest = true;
		});

		this.Hook.addAction('submitFormAfterSubmit', (form, formAction) => {
			this.#sentSubmitRequest = false;
		});

		this.Hook.addAction('submitFormSuccess', (response, form, formAction) => {
			if (response?.redirect_url) {
				setTimeout(() => {
					window.location = response.redirect_url
				}, 200)
			}
		});

		this.Hook.addAction('submitFormFail', (response, form, formAction) => {
			if (response?.redirect_url) {
				setTimeout(() => {
					window.location = response.redirect_url
				}, 200)
			}
		});
	}

    #addEvents() {
        this.Hook.doAction('addEvents');
    }

    #addWatchers() {
        this.Hook.doAction('addWatchers')
    }

    observeElements (selector, elementCallback) {
        return DOM.observeElements(selector, elementCallback);
    }

    handleEvent(event, selector, callback, eventElement = null) {
		let element = null;

		if (eventElement) {
			element = eventElement;
		} else {
			element = this.formWrapper;
		}

		return DOM.addEvent(event, selector, callback, element);
    }

    element(element, selector) {
        return DOM.compareElement(element, selector);
    }

    async error(field, text = '',form = null, scrollTop = true) {
        field?.classList?.add('error');

        if (field && form === null){
            form = field.closest('form')
        }

        if (field?.closest('.review-wrapper')) {
            field.closest('.form-group')?.classList.add('error')
        }

        if (field?.closest('.choices')){
            field.closest('.choices').classList.add('error')
        }

		text = this.Hook.applyFilters('errorMessage', text, field, form);

		if (form?.querySelector('.levcharity-errors-container') && text) {
			const errorContainer = form.querySelector('.levcharity-errors-container');
			const existingMessages = Array.from(errorContainer.querySelectorAll('.error-message'));

			const uniqueId = `error-${text.replace(/\s+/g, '-').toLowerCase()}`;

			const isDuplicate = existingMessages.some(message => message.id === uniqueId);

			if (!isDuplicate) {
				errorContainer.insertAdjacentHTML('afterbegin', `<p id="${uniqueId}" class="error-message" style="display:none">${text}</p>`);

				const {Notifications} = await import('../../helpers/Notifications.js')

				new Notifications()
					.setMessage(text)
					.setType('error')
					.setTimeout(15000)
					.execPopup();

				if (!field && scrollTop){
					window.scrollTo(0,0);
				}
			}
        }
		if (!field && scrollTop) {
			window.scrollTo(0, 0);
		}
    }

    clearErrors() {
        const errorFields = this.formWrapper.querySelectorAll('.error');
        const errorMessages = this.formWrapper.querySelectorAll('.error-message');

        for (const field of errorFields) {
            field.classList.remove('error');
        }

        for (const message of errorMessages) {
            message.remove();
        }
    }

    async submitForm(form, action, addLoader = true) {
        let formData = new FormData(form);

        return await new Promise(async (resolve, reject) => {

            if (addLoader && !document.body.classList.contains('ajax-loading')) {
                document.body.classList.add('ajax-loading');
            }

            await fetch(
                `${admin_ajax[0]}?action=${action}`,
                {
                    method: 'POST',
                    body: formData,
                }
            )
            .then(response => {
                return response.json()
            })
            .then(response => {
                if (response?.success) {
                    resolve(response)
                } else {
                    reject(response);
                }
            })
            .catch(response => {
                reject(response);
            })
            .finally(() => {
                if (document.body.classList.contains('ajax-loading')) {
                    document.body.classList.remove('ajax-loading');
                }
            });
        });
    }

    validateFields(form) {
        const fields = form.querySelectorAll('input,textarea,select');

        const letterRegex = /[a-zA-Z]/;
        const numberRegex = /\d/;
		const symbolRegex = /[!@#$%^&*()_+{}\[\]:;<>,.?/~\\\-=`]/;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        let password = false;
        let confirmPassword = false;

        let isValid = true;

		const radioFields = [];

        for (const field of fields) {
            if (field.disabled) continue;

            if (field.required && (field.type === 'checkbox' || field.type === 'radio') && !field.checked){
				let displayError = true;
				if (field.type === 'radio') {
					this.formWrapper.querySelectorAll(`input[type="radio"][name="${field.name}"]`)
						.forEach(el => {
							if (el.checked) {
								displayError = false;
							}
						})
				}

				if (displayError && (field.type !== 'radio' || !radioFields.includes(field.name))) {
					if (field.type === 'radio') radioFields.push(field.name);
					const formattedFieldName = field.name.replace('cf[', '').replace(/\[/g, ' ').replace(/\]/g, ' ').split(/[-_]/).filter(n => n)
						.map(word => {
							return word.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
						})
						.join(' ');
					this.error(field, formattedFieldName + ' Shouldn\'t be empty.');
					isValid = false;
				}
            }

            if (field.required && !field.value) {
				const formattedFieldName = field.name.replace('cf[', '').replace(/\[/g, ' ').replace(/\]/g, ' ').split(/[-_]/).filter(n => n)
					.map(word => {
						return word.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
					})
					.join(' ');
                this.error(field, formattedFieldName + ' Shouldn\'t be empty.');
                isValid = false;
            } else if (['password', 'confirm-password'].includes(field.dataset.type)) {
                if ((!letterRegex.test(field.value) || !numberRegex.test(field.value) || !symbolRegex.test(field.value) || field.value.length < 7) && (!field.dataset?.type || field.dataset?.type && field.dataset.type === 'password')) {
                    this.error(field, wp.i18n.__('Password is not valid', 'levcharity'));
                    isValid = false;
                }

                if (field.dataset && field.dataset.type === 'password') {
                    password = field.value;
                } else if (field.dataset && field.dataset.type === 'confirm-password') {
                    confirmPassword = field.value;
                }
            } else if (field.type === 'email') {
                if (field.value && !emailRegex.test(field.value)) {
                    this.error(field, wp.i18n.__('Email address is not valid.', 'levcharity'));
                    isValid = false;
                }
            } else if(['team_campaign_goal_other_amount', 'campaign_goal_other_amount'].includes(field.name)){
				if (field?.value !== '' && field?.value < 1){
					this.error(field, wp.i18n.__('Goal amount must be greater than 1.', 'levcharity'));
					isValid = false;
				}
			}
        }


        if (password !== false && confirmPassword !== false && password !== confirmPassword) {
            this.error(null, wp.i18n.__('Password Mismatch.', 'levcharity'), form);
            isValid = false;
        }

        return isValid;
    }

    setCookie(name, value, daysToExpire) {
        var expirationDate = new Date();
        expirationDate.setDate(expirationDate.getDate() + daysToExpire);

        document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expirationDate.toUTCString() + '; path=/';
    }

    getCookie(name) {
        var cookies = document.cookie.split(';');

        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i].trim();

            if (cookie.indexOf(name + '=') === 0) {
                return decodeURIComponent(cookie.substring(name.length + 1));
            }
        }

        return null;
    }
}
